"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgMapEnlarge = function SvgMapEnlarge(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M693.127 0v78.77h252.109v252.06H1024V0H693.127zM0 0v330.83h78.764V78.77H330.81V0H0zm945.236 693.232v251.999h-252.11V1024H1024V693.232h-78.764zM0 693.232V1024h330.81v-78.77H78.764V693.233H0z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgMapEnlarge, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;